import type { IconSvgObject } from './types';

const PackageIcon: IconSvgObject = [
  ["path", { d: "M11.998 10L20.998 6L11.998 2L2.99805 6L11.998 10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.498 4L7.49805 8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.00195 6V18L11.998 22M11.998 22L21.002 18V6.01357M11.998 22V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5.99805 11L8.49805 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PackageIcon;
